/* Broadcast Theme
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.*/
(function() {
  [...document.querySelectorAll('h2.h3.footer__block__title')].forEach(ft=>{ft.onclick=()=>{ft.nextElementSibling.classList.toggle('open');}});
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
